import gql from 'graphql-tag';

export default gql`
  mutation UpdateBillingMethod($accountId: ID!, $paymentId: ID!) {
    updateBillingMethod(accountId: $accountId, paymentId: $paymentId) {
      __typename
    }
  }
`;
